import EventEmitter from 'methods/eventEmitter';
import GeoPicker from 'components/geopicker';
import DateRangePicker from 'components/daterangepicker-dropdown';
import PeoplePicker from 'components/peoplepicker';
import {ajaxSetData} from 'methods/ajaxData';
import {checkLocalStorage, isMobile} from 'methods/utils';

function Search($container, options = {}) {
    // наследуемся
    EventEmitter.call(this);

    this._$container = typeof $container === 'undefined' ? document.body : $container;
    this._$form      = this._$container.classList.contains('js-filterForm') ? this._$container : this._$container.querySelector('.js-filterForm');

    // поддержка localStorage
    this._supportLocalStorage = checkLocalStorage();

    // событие, когда закрываем модалки
    this._hideEvent = function () {
        // прокидываем дальше
        this.emit('hide');
    }

    // нет поиска по географии
    if (!this._$form.querySelector('.js-searchInput')) {
        options.disableGeoSearch = true;
    }

    // поиск по географии
    if (options.disableGeoSearch !== true) {
        this._geoPicker = new GeoPicker($container, {
            formId: options.formId,
            _search: this,
        });

        this._geoPicker.on('city:change', () => {
            const data = this.getData();

            if (!data.date_start && !data.date_finish) {
                setTimeout(() => this._datePicker.open(), 100);
            }
        });
    }

    this.withPets = typeof options.withPets == "undefined" ? true : options.withPets;
    this.peopleSelected = typeof options.peopleSelected == "undefined" ? null : options.peopleSelected;

    this._datePickerOptions = {...options, ...{
        restrictions: options.calendarData?.restrictions,
        $inputDateStart:  this._$form.querySelector('[name="date_start"]'),
        $inputDateFinish: this._$form.querySelector('[name="date_finish"]'),
        formInputClass: 'date-input',
        on: {
            // rangeSelect: (date_from, date_to) => {
            //     setTimeout(function() {
            //         this._peoplePicker.canOpenAfterDate();

            //         // сброс ценовых фильтров
            //         this.emit('priceSearchReset');
            //     }.bind(this), 300);
            // },
            close: this._hideEvent.bind(this),
        },
        formId: options.formId,
    }};

    if (options.on) {
        this._datePickerOptions.on = Object.assign(this._datePickerOptions.on, options.on);
    }

    // поиск по датам
    this._$dateRangePicker = this._$form.querySelector('.js-dateRangePicker');
    this._shortMonthNames  = ['янв', 'фев', 'мар', 'апр', 'май', 'июн', 'июл', 'авг', 'сен', 'окт', 'ноя', 'дек'];
    this._datePicker       = new DateRangePicker(this._$dateRangePicker, this._datePickerOptions);
    this._formSubmitionCancelled = false;

    if (options.enableErrorFields === true) {
        let $errorContainer = document.querySelector('.js-errorContainer');

        this._dateErrorField = document.createElement('div');
        this._dateErrorField.classList.add('error-field');

        if ($errorContainer) {
            $errorContainer.appendChild(this._dateErrorField);
        }
    }

    // поиск по людям
    this._$peoplePicker = this._$form.querySelector('.js-peoplePicker');
    this._peoplePicker = new PeoplePicker(this._$peoplePicker, {
        formInputClass: 'people-input',
        withPets: this.withPets,
        formId: options.formId,
        peoplePosition: options.peoplePosition,
        peopleSelected: this.peopleSelected,
    });

    if (options.enableErrorFields === true) {
        this._peopleErrorField = document.createElement('div');
        this._peopleErrorField.classList.add('error-field');
        this._$peoplePicker.appendChild(this._peopleErrorField);
    }

    this._peoplePicker.on('withPets', (data) => {
        const $option = document.querySelector('input[name="option_list[34]"]');
        if (!$option) {
            return;
        }

        const $checkboxContainer = $option.closest('.js-checkboxItemContainer');
        const $checkboxItem = $checkboxContainer.querySelector('.js-checkboxItem');
        $option.checked = !!data.value;
        $checkboxItem.classList.toggle('is-active', !!data.value);
    });

    // данные для поиска
    this.setData = function(data = {}) {
        this.disableCallbacks = true;

        if (window?.hotelPortal?.setDatesForCheckPrice) {
            window.hotelPortal.setDatesForCheckPrice(data.date_start, data.date_finish);
        }

        // география
        if (data.search_title && this._geoPicker) {
            this._geoPicker.setSearchTitle(data.search_title);
        }

        if (data.search_href && this._geoPicker) {
            this._geoPicker.setSearchHref(data.search_href);
        }

        // даты
        if (data.date_start && data.date_finish) {
            // _disableCallbacks нужен, чтобы не отрабатывал callback rangeSelect
            this._datePicker._disableCallbacks = true;
            this._datePicker.rangeSelect(new Date(data.date_start), new Date(data.date_finish));

            // apply нужен, чтобы прокидывать даты в рендер
            this._datePicker.apply();
            this._datePicker._disableCallbacks = false;

            this.emit('initDatepicker');
        } else {
            this.emit('noInitDatepicker');
        }

        // люди
        if (data.adults) {
            this._peoplePicker.setAdults(data.adults);
        }

        this._peoplePicker.setChildrenOlds(data.children_olds);

        if (this.withPets) {
            this._peoplePicker.withPets(!!data.with_pets);
        }

        this.disableCallbacks = false;
    }

    this.getData = function() {
        return {
            date_start: this._datePicker.formatDate(this._datePicker.getDateFrom()),
            date_finish: this._datePicker.formatDate(this._datePicker.getDateTo()),
            adults: this._peoplePicker.getAdults(),
            childrens: this._peoplePicker.getChildrens(),
            children_olds: this._peoplePicker.getChildrenOlds(),
            with_pets: this._peoplePicker.getWithPets(),
        }
    }

    this.cancelSubmition = function() {
        this._formSubmitionCancelled = true;
    }

    // submit формы поиска
    this._$searchErrorItem  = this._$form.querySelector('.js-searchErrorItem');
    this._$searchErrorTitle = this._$form.querySelector('.js-searchErrorTitle');
    this._$searchInput      = this._$form.querySelector('.js-searchInput');
    this._formSubmit = function(e) {
        e.preventDefault();
        e.stopPropagation();

        // повторный вызов формы
        if (this._$form.classList.contains('is-loading')) {
            return false;
        }
        this._$form.classList.add('is-loading');

        // снимаем ошибки
        if (this._$searchErrorItem) {
            this._$searchErrorItem.classList.remove('is-active');
        }

        // не выбрана география в поиске
        if (this._$searchInput && !this._$searchInput.dataset.href) {
            this._$searchErrorItem.classList.add('is-active');
            this._$searchErrorTitle.textContent = 'Пожалуйста, укажите название курорта';
            this._$form.classList.remove('is-loading');
            return;
        }

        // свой formSubmit
        this.emit('submit', {
            redirect: this._$searchInput && this._$searchInput.dataset.href !== location.pathname,
        });

        if (this._formSubmitionCancelled) {
            this._formSubmitionCancelled = false;
            this._$form.classList.remove('is-loading');
            return;
        }

        let formData     = new FormData(this._$form);
        let formDataDiff = true;

        if (this._$form.elements['search_input']) {
            (window['rrApiOnReady'] = window['rrApiOnReady'] || []).push(() => {
                try{ rrApi.search(this._$form.elements['search_input'].value); } catch(e) {}
            });
        }

        if (this.lastFormData && formData && JSON.stringify([...formData.entries()]) === JSON.stringify([...this.lastFormData.entries()])) {
            formDataDiff = false;
        }

        this.lastFormData = formData;

        // сохраняем поля поиска и переходим
        if (formDataDiff) {
            ajaxSetData(formData)
                .then((r) => {
                    if (r.status === 'ok' && this._$searchInput) {
                        setTimeout(() => {
                            this._saveSearch();

                            // сохраняем результаты поиска
                            if (this._$searchInput.dataset.href !== location.pathname) {
                                location.href = this._$searchInput.dataset.href;
                            } else {
                                let parts = location.pathname.split('/').filter(str => str.length > 0 ? str : false);

                                if (parts.length === 1 && [1, 4, 8].indexOf(+document.body.dataset.page_type_id) !== -1) {
                                    location.pathname = location.pathname + 't_best/';
                                    return;
                                }
                            }
                        }, 100);
                    }

                    this._$form.classList.remove('is-loading');
                });
        } else {
            this._$form.classList.remove('is-loading');
        }
    }
    this._$searchButton = this._$form.querySelector('.js-searchButton');

    // submit формы
    this._$form.addEventListener('submit', this._formSubmit.bind(this));

    // сохраняем поиск формы
    this._saveSearch = function() {
        if (!this._supportLocalStorage) {
            return;
        }

        let data = {
            searchTitle: this._$searchInput.value,
            searchHref: this._$searchInput.dataset.href,
            city: this._$searchInput.dataset.city ? this._$searchInput.dataset.city : '',
            startDate: this._datePicker.formatDate(this._datePicker.getDateFrom()),
            endDate: this._datePicker.formatDate(this._datePicker.getDateTo()),
            adults: this._peoplePicker.getFilledAdults(),
            childrens: this._peoplePicker.getChildrens(),
            childrenOlds: this._peoplePicker.getChildrenOlds(),
            withPets: this._peoplePicker.getWithPets(),
        }

        if (!data.searchHref || !data.searchTitle) {
            return;
        }

        let limit = 3;
        let saveSearchData = localStorage.getItem('saveSearch');
        saveSearchData = !saveSearchData ? [] : JSON.parse(saveSearchData);

        // удаляем ранее добавленный
        let isDeleted = false;
        saveSearchData.forEach((item, i) => {
            if (item.searchHref == data.searchHref) {
                saveSearchData.splice(i, 1);
                isDeleted = true;
            }
        });

        // если ничего не удалили то удаляем до лимита
        if (!isDeleted) {
            saveSearchData = saveSearchData.slice(0, limit - 1);
        }

        // сохр наш
        saveSearchData.push(data);
        localStorage.setItem('saveSearch', JSON.stringify(saveSearchData));
    }

    // сохр данные по поиску туриста
    this._getSearch = function() {
        if (!this._supportLocalStorage) {
            return [];
        }

        let limit = 3;
        let saveSearchData = localStorage.getItem('saveSearch');
        saveSearchData = !saveSearchData ? [] : JSON.parse(saveSearchData);

        return saveSearchData;
    }

    this.loadSearch = function(data) {
        this.disableCallbacks = true;

        if (window?.hotelPortal?.setDatesForCheckPrice) {
            window.hotelPortal.setDatesForCheckPrice(data.startDate, data.endDate);
        }

        // география
        if (data.searchTitle && this._geoPicker) {
            this._geoPicker.setSearchTitle(data.searchTitle);
        }

        if (data.searchHref && this._geoPicker) {
            this._geoPicker.setSearchHref(data.searchHref);
        }

        // даты
        if (data.startDate && data.endDate) {
            // _disableCallbacks нужен, чтобы не отрабатывал callback rangeSelect
            this._datePicker._disableCallbacks = true;
            this._datePicker.rangeSelect(new Date(data.startDate), new Date(data.endDate));

            // apply нужен, чтобы прокидывать даты в рендер
            this._datePicker.apply();
            this._datePicker._disableCallbacks = false;

            this.emit('initDatepicker');
        } else {
            this.emit('noInitDatepicker');
        }

        // люди
        if (data.adults > 0) {
            this._peoplePicker.setAdults(data.adults);

            this._peoplePicker.setChildrenOlds(data.childrenOlds);

            if (this.withPets) {
                this._peoplePicker.withPets(!!data.withPets);
            }
        }

        this.disableCallbacks = false;
    }

    // клик по кнопке найти
    if (this._$searchButton) {
        this._$searchButton.addEventListener('click', function(e) {
            this._formSubmit.bind(this)(e);
            this.emit('searchButton');
        }.bind(this));
    }

    // change полей формы
    this._$form.addEventListener('change', function(e) {
        if (this.disableCallbacks === true) {
            return;
        }

        // при вводе города полагаемся только на выбор города из модалки
        // при вводе текста не отправляется запрос ajax
        if (e.target.name == 'search_input') {
            return;
        }

        this.emit('change', this.getData());
    }.bind(this));

    // при закрытие внутренних модалок, убирался класс с body и работал scroll

    if (this._geoPicker) {
        this._geoPicker.on('hide', this._hideEvent.bind(this));
    }
    this._peoplePicker.on('hide', this._hideEvent.bind(this));

    // TODO вот это сделать и удалить
    // subscribeEvent('kurortSearchDatepickerReset', this._datePicker.rangeReset);
    // subscribeEvent('peoplePickerWithPetsCallback', this._peoplePicker.withPetsCallback)

    // сброс поиска
    this.reset = function() {
        this._peoplePicker.reset();
        this._datePicker.rangeReset();
    }

    /**
     * Название выбранной географии
     */
    this.getCitySearch = function() {
        let defaultValue = options.defaultCityTitle ? options.defaultCityTitle : 'Курорт';

        if (typeof this._geoPicker === 'undefined' || !this._geoPicker.getSearchTitle()) {
            return defaultValue;
        }

        return this._geoPicker.getSearchTitle();
    }

    /**
     * Выбранные даты в формате 07 июл - 20 июл
     */
    this.getPeriodSearch = function() {
        const defaultValue = 'Выберите даты';

        if (typeof this._datePicker === 'undefined') {
            return defaultValue;
        }

        const dateFrom = this._datePicker.getDateFrom();
        const dateTo   = this._datePicker.getDateTo();

        if (!dateFrom || !dateTo) {
            return defaultValue;
        }

        return `${dateFrom.getDate()} ${this._shortMonthNames[dateFrom.getMonth()]} - ${dateTo.getDate()} ${this._shortMonthNames[dateTo.getMonth()]}`;
    }

    /**
     * Наличие дат
     */
    this.hasDates = function () {
        return this._datePicker.hasDates();
    }

    /**
     * Количество ночей
     */
    this.daysCount = function () {
        return this._datePicker.daysCount();
    }

    /**
     * Кол-во человек
     */
    this.getPeopleSearch = function() {
        let defaultValue = '2 гостя';

        if (typeof this._peoplePicker === 'undefined') {
            return defaultValue;
        }

        return this._peoplePicker.getSearchTitleFull();
    }

    /**
     * Показываем ошибки
     */
    this.showError = function(message = {}) {
        if (message === Object(message) && !Array.isArray(message)) {
            if (message.field === 'date') {
                this._dateErrorField.textContent = message.message;
                this._dateErrorField.classList.add('active');

                this._$form.classList.add('error');
            } else {
                this._peopleErrorField.textContent = message.message;
                this._peopleErrorField.classList.add('active');
            }
        } else {
            this._peopleErrorField.textContent = message;
            this._peopleErrorField.classList.add('active');
        }
    }

    /**
     * Скрываем ошибки
     */
    this.hideError = function() {
        this._dateErrorField.classList.remove('active');
        this._peopleErrorField.classList.remove('active');
        this._$form.classList.remove('error');
    }
}

// цепочка прототипов
Search.prototype = Object.create(EventEmitter.prototype, {
    constructor: {
        value: Search,
        enumerable: false,
        writable: true,
    }
});

Search.prototype.openDatePicker = function () {
    this._datePicker.open();
}

export default Search;
